import axios from 'axios';

// Reportería y dashboard ejecutivo (propuesta integral Fase 6, doc 04 §2/§3/§4).
// El baseURL de axios ya incluye el prefijo /{tenant}/.
//
// NOTA: la Fase 5 (encuestas, casos y taquizas) está DIFERIDA. Los reportes 10
// (events/taquizas) y 14 (voc) devuelven { feature_disabled: true, phase: "5" }
// y las pestañas quedan ocultas por los flags events.taquizas / surveys.
export default {
  // Ejecuta un reporte ejecutivo. name ∈ summary|sales|channel-mix|funnel|
  // customer-profile|loyalty|tiers|promotions|app-conversion|delivery-ops|
  // referrals|finance|alerts|benefit-roi (events/voc → Fase 5 diferida).
  run(name, filters) {
    return axios.post(`/report/exec/${name}`, filters || {});
  },

  // Drill-down: mismo endpoint con { ...filters, drill: { level, key } }.
  drill(name, filters, drill) {
    return axios.post(`/report/exec/${name}`, Object.assign({}, filters, { drill }));
  },

  // Exporta las filas del reporte a Excel (?format=xlsx → backend excelize).
  exportXlsx(name, filters) {
    return axios.post(`/report/exec/${name}?format=xlsx`, filters || {}, {
      responseType: 'blob'
    });
  },

  // Alertas (Reporte 13): asignar / resolver.
  updateAlert(id, payload) {
    return axios.put(`/report/alerts/${id}`, payload);
  },

  // Detalle de un ticket/folio (TicketDrawer).
  ticketDetail(sucursalId, ticketId) {
    return axios.get(`/ticket/${sucursalId}/${ticketId}/detail`);
  },

  // Vista 360° de un cliente.
  customer360(customerId) {
    return axios.get(`/customers/${customerId}/360`);
  }
}
